import React, { useState } from "react";
import styled from "styled-components";
import { Row, Col, Collapse, Card, CardBody } from "reactstrap";
import { Colors, OutputRow, TableIcon, BoldLabel, ButtonContainer, CollapseButton, CollapseRow } from "../../../../utils/budget-tool-specific";
import { useEffect } from "react";
import MealsBreakdownRow from "../../../budget/budget-tool/cost-output/meals-breakdown-row";
import SubtotalCols from "./subtotal-cols";
import { displayValue } from "../../helper";
import CostRow from "./exp-cost-row";
import { exchangeRate } from "./cost-helper";

const MealRow = ({guideData, expData}) => {

    const [breakdownOpen, setBreakdownOpen] = useState(false);

    // Use guide-level meal counts if available, otherwise fall back to experience-level
    const numBreakfast = guideData.numBreakfast?.value ?? expData.numBreakfast?.value ?? 0;
    const numLunch = guideData.numLunch?.value ?? expData.numLunch?.value ?? 0;
    const numDinner = guideData.numDinner?.value ?? expData.numDinner?.value ?? 0;
    const numAlcohol = guideData.numAlcohol?.value ?? expData.numAlcohol?.value ?? 0;

    let data = {
        breakfast: {
            title: "Breakfast",
            costPer: exchangeRate(expData, expData.costPerBreakfast.value),
            numNights: numBreakfast,
            cost: exchangeRate(expData, expData.costPerBreakfast.value * numBreakfast),
        },
        lunch: {
            title: "Lunch",
            costPer: exchangeRate(expData, expData.costPerLunch.value),
            numNights: numLunch,
            cost: exchangeRate(expData, expData.costPerLunch.value * numLunch)
        },
        dinner: {
            title: "Dinner",
            costPer: exchangeRate(expData, expData.costPerDinner.value),
            numNights: numDinner,
            cost: exchangeRate(expData, expData.costPerDinner.value * numDinner)
        },
        alcohol: {
            title: "Drinks",
            costPer: exchangeRate(expData, expData.costPerAlcohol.value),
            numNights: numAlcohol,
            cost: exchangeRate(expData, expData.costPerAlcohol.value * numAlcohol)
        }
    }

    const cost = data.alcohol.cost + data.dinner.cost + data.lunch.cost + data.breakfast.cost;

    const toggleCollapse = () => {

        if (breakdownOpen === true) {
            setBreakdownOpen(false);
        } else {
            setBreakdownOpen(true);
        }
    }
    

    const normalStyle = {
        transition: '1s, transform 0.5s',
    };
      
    const transformedStyle = {
        transition: '1s, transform 0.5s',
        transform: 'rotate(180deg)',
    };

    return (
        <React.Fragment>
            <CostRow title="Meals" 
                icon='utensils'
                height
                detail
                isOpen={breakdownOpen}
                setIsOpen={setBreakdownOpen}
                currency={guideData.currency.value.slice(3)} 
                subtotal={cost}
                attendees={guideData.attendees.value}/>
            <Collapse isOpen={breakdownOpen}>
                <CollapseRow>
                        <Col>
                            <PinkCard>
                            <PaddedCardBody>
                                
                                {Object.entries(data).map((element, i) => {
                                    
                                    if (element[1].cost !== 0){
                                        return (
                                                <MealsBreakdownRow key={i}
                                                                title={element[1].title} 
                                                                costPer={element[1].costPer}
                                                                numNights={element[1].numNights}
                                                                cost={element[1].cost}
                                                                currency={guideData.currency.value.slice(3)}/>
                                        )
                                    } else {
                                        return <React.Fragment key={i}/>
                                    }
                                    
                                })}
                                
                            </PaddedCardBody>
                            </PinkCard>
                        </Col>
                </CollapseRow>
            </Collapse>
        </React.Fragment>
    )
}

export default MealRow;

const PinkCard = styled(Card)`
    background-color: ${Colors.primaryAccent};
    border: none;
`

const PaddedCardBody = styled(CardBody)`
    padding: 15px 30px;
`